class ProviderSearchPermissionChecker {
  hasPermission(currentUser, path) {
    if (!currentUser) {
      return false;
    }

    const { typeCd: userTypeCd } = currentUser;

    return userTypeCd === "IRAD" || userTypeCd === "ISAD";
  }
}

export default new ProviderSearchPermissionChecker();
